import Vue from 'vue'
import Router from 'vue-router'

// 表示する画面のページのインポートをここに記載すること

import AppPasswordInitialization from '@/components/mock/AppPasswordInitialization'
import AppPasswordForceChange from '@/components/mock/AppPasswordForceChange'
import login from '@/components/mock/login'
import SSOLogin from '@/components/mock/SSOLogin'

//外部ユーザー
import guestIndex from '@/components/mock/guest/index'
import guestHome from '@/components/mock/guest/home'
import kensaMenu from '@/components/mock/guest/kensaMenu'
import HSTRequest from '@/components/mock/guest/HSTRequest'
import PSGRequest from '@/components/mock/guest/PSGRequest'
import KenshinRequest from '@/components/mock/guest/KenshinRequest'
import RequestFormList from '@/components/mock/guest/RequestFormList'
import DealersFacilityManagement from '@/components/mock/guest/DealersFacilityManagement'
import GuestSetting from '@/components/mock/guest/GuestSetting'
import KenshinJudgment from '@/components/mock/guest/KenshinJudgment'
import KenshinJudgmentDetail from '@/components/mock/guest/KenshinJudgmentDetail'
import HolterAnalysisJudgment from '@/components/mock/guest/HolterAnalysisJudgment'
import HolterAnalysisJudgmentDetail from '@/components/mock/guest/HolterAnalysisJudgmentDetail'
import HolterAnalysisJugdmentMonthlyReport from '@/components/mock/guest/HolterAnalysisJugdmentMonthlyReport'
import PSGAnalysisOrder from '@/components/mock/guest/PSGAnalysisOrder'
import PSGAnalysisOrderDetail from '@/components/mock/guest/PSGAnalysisOrderDetail'
import AnalysisReportGuest from '@/components/mock/guest/AnalysisReportGuest'
import HolterRequest from '@/components/mock/guest/HolterRequest'
import HolterAnalysisRequest from '@/components/mock/guest/HolterAnalysisRequest'
import HolterDepositMachineRequest from '@/components/mock/guest/HolterDepositMachineRequest'
import HolterAnalysisReport from '@/components/mock/philips/spreadSheet/HolterAnalysisReport'
import HolterDepositMachineList from '@/components/mock/guest/HolterDepositMachineList'
import HolterDepositMachineRequestFormOrder  from '@/components/mock/guest/HolterDepositMachineRequestFormOrder'
import HolterAnalysisResultGuest  from '@/components/mock/guest/HolterAnalysisResultGuest'
import HolterAnalysisResultGuestDetail  from '@/components/mock/guest/HolterAnalysisResultGuestDetail'
import ArticleList from './components/mock/guest/ArticleList.vue'
import inspectionReportList from '@/components/mock/guest/inspectionReportList'
import InspectionReportView from '@/components/mock/guest/InspectionReportView'

//社外ユーザー　ケアオーケストレーター
import CORegistRequest from '@/components/mock/guest/careorchestrator/CORegistRequest'
import COApplicationForRegistered from '@/components/mock/guest/careorchestrator/COApplicationForRegistered'
import COSettingHospital from '@/components/mock/guest/careorchestrator/COSettingHospital'
import COSettingUser from '@/components/mock/guest/careorchestrator/COSettingUser'
import COSettingRequestList from '@/components/mock/guest/careorchestrator/COSettingRequestList'
import COSettingClientCertificate from '@/components/mock/guest/careorchestrator/COSettingClientCertificate'
import CODealerMenu from '@/components/mock/guest/careorchestrator/CODealerMenu'
import CODealerHospitalSearch from '@/components/mock/guest/careorchestrator/CODealerHospitalSearch'
import CODealerSettingHospital from '@/components/mock/guest/careorchestrator/CODealerSettingHospital'
import CODealerSettingUser from '@/components/mock/guest/careorchestrator/CODealerSettingUser'
import CODealerRequestList from '@/components/mock/guest/careorchestrator/CODealerRequestList'
import CODealerSettingClientCertificate from '@/components/mock/guest/careorchestrator/CODealerSettingClientCertificate'
//社外ユーザ登録フォーム
import RegistNavi from '@/components/mock/guest/regist/RegistNavi'
import RegistForm from '@/components/mock/guest/regist/RegistForm'
import RegistForm2 from '@/components/mock/guest/regist/RegistForm2'

//社外ユーザ登録フォーム(外部ユーザー追加依頼)
import userAddRegistForm from '@/components/mock/guest/regist/userAddRegistForm'
//社外申込み内容確認サイト
import requestViewer from '@/components/mock/guest/requestUrl/requestViewer'
//社外再検査実施/キャンセルサイト
import reExaminationAdjustment from '@/components/mock/guest/requestUrl/reExaminationAdjustment'
//解析結果ダウンロードサイト
import ResultDownload from '@/components/mock/common/ResultDownload'

//社外ユーザー　CPAP
import CpapMenu from '@/components/mock/guest/cpap/CpapMenu'
import CpapRequest from '@/components/mock/guest/cpap/CpapRequest'
import CpapInstrumentRequest from '@/components/mock/guest/cpap/CpapInstrumentRequest'
import CpapInstrumentList from '@/components/mock/guest/cpap/CpapInstrumentList'
import CpapPatientList from '@/components/mock/guest/cpap/CpapPatientList'
import CpapPatientDetail from '@/components/mock/guest/cpap/CpapPatientDetail'
import CpapInstrumentDetail from '@/components/mock/guest/cpap/CpapInstrumentDetail'
import CpapHospitalTransfer from '@/components/mock/guest/cpap/CpapHospitalTransfer'
import CpapCancelDetail from '@/components/mock/guest/cpap/CpapCancelDetail'
import CpapUsedList from '@/components/mock/guest/cpap/CpapUsedList'
import CpapRequestList from '@/components/mock/guest/cpap/CpapRequestList'
import CpapGuestRequestDetail from '@/components/mock/guest/cpap/CpapRequestDetail'
import CpapDefaultSettingList from '@/components/mock/guest/cpap/CpapDefaultSettingList'
import CpapDefaultSetting from '@/components/mock/guest/cpap/CpapDefaultSetting'
import CpapRequestMenu from '@/components/mock/guest/cpap/CpapRequestMenu'
import CpapEscrowRequest from '@/components/mock/guest/cpap/CpapEscrowRequest'
import CpapEscrowRequestList from '@/components/mock/guest/cpap/CpapEscrowRequestList'
import CpapGuestEscrowRequestDetail from '@/components/mock/common/CpapEscrowRequestDetail'
import CpapRequestDraftView from './components/mock/guest/cpap/CpapRequestDraftView.vue'

//社外ユーザー　患者ダッシュボード
import PDashboardMain from '@/components/mock/guest/patientdashboard/PDashboardMain.vue'

//社内ユーザー共通
import philipsIndex from '@/components/mock/philips/index'
import philipsHome from '@/components/mock/philips/home'
import devToolHome from '@/components/mock/philips/dev/devToolHome'
import NowCreating from '@/components/mock/philips/common/NowCreating'
//社内ユーザー案件一覧
import RequestSearch from '@/components/mock/philips/search/RequestSearch'
import RequestDetail from '@/components/mock/philips/search/RequestDetail'
import RequesKenshintDetail from '@/components/mock/philips/search/RequesKenshintDetail'

//社内ユーザー代理申込
import offerHome from '@/components/mock/philips/offer/offerHome'
import HSTAgentLabelPrint from '@/components/mock/philips/offer/HSTAgentLabelPrint'

//社内ユーザーHST
import HSTRequestAccept from '@/components/mock/philips/hst/HSTRequestAccept'
import HSTRequestAcceptDetail from '@/components/mock/philips/hst/HSTRequestAcceptDetail'
import HSTDevicePreparation from '@/components/mock/philips/hst/HSTDevicePreparation'
import HSTDevicePreparationDetail from '@/components/mock/philips/hst/HSTDevicePreparationDetail'
import HSTShippingList from '@/components/mock/philips/hst/HSTShippingList'
import HSTShippingDetail from '@/components/mock/philips/hst/HSTShippingDetail'
import shippngIndex from '@/components/mock/philips/hst/shipping/index'
import HSTPaymentNumberBulkSetting from '@/components/mock/philips/hst/shipping/HSTPaymentNumberBulkSetting'
import HSTInvoiceBulkSetting from '@/components/mock/philips/hst/shipping/HSTInvoiceBulkSetting'
import HSTInvoiceSheetView from '@/components/mock/philips/hst/shipping/HSTInvoiceSheetView'
import HSTLabel12SheetView from '@/components/mock/philips/hst/shipping/HSTLabel12SheetView'
import HSTShippingDirectionsView from '@/components/mock/philips/hst/shipping/HSTShippingDirectionsView'
import HSTNumberOfShipmentSummary from '@/components/mock/philips/hst/HSTNumberOfShipmentSummary'
import HSTDeviceReturn from '@/components/mock/philips/hst/HSTDeviceReturn'
import HSTAnalysisOrder from '@/components/mock/philips/hst/HSTAnalysisOrder'
import HSTAnalysisOrderDetail from '@/components/mock/philips/hst/HSTAnalysisOrderDetail'
import HSTRequestSearch from '@/components/mock/philips/hst/HSTRequestSearch'
import HSTRequestSearchDetail from '@/components/mock/philips/hst/HSTRequestSearchDetail'
import HSTRequestContentChange from '@/components/mock/philips/hst/HSTRequestContentChange'
import HSTDetailEdit from '@/components/mock/philips/hst/HSTDetailEdit'

//社内ユーザーPSG
import PSGRequestAccept from '@/components/mock/philips/psg/PSGRequestAccept'
import PSGRequestAcceptDetail from '@/components/mock/philips/psg/PSGRequestAcceptDetail'
import PSGAnalyisisResult from '@/components/mock/philips/psg/PSGAnalyisisResult'
import PSGAnalyisisResultDetail from '@/components/mock/philips/psg/PSGAnalyisisResultDetail'
import PSGApproval from '@/components/mock/philips/psg/PSGApproval'
import PSGApprovalDetail from '@/components/mock/philips/psg/PSGApprovalDetail'

//社内ユーザー ホルター心電図配送ｻｰﾋﾞｽ
import holterMenu from '@/components/mock/guest/holterMenu'
import HolterRequestAccept from '@/components/mock/philips/holter/HolterRequestAccept'
import HolterRequestAcceptDetail from '@/components/mock/philips/holter/HolterRequestAcceptDetail'
import HolterDevicePreparation from '@/components/mock/philips/holter/HolterDevicePreparation'
import HolterDevicePreparationDetail from '@/components/mock/philips/holter/HolterDevicePreparationDetail'
import HolterShippingList from '@/components/mock/philips/holter/HolterShippingList'
import HolterShippingDetail from '@/components/mock/philips/holter/HolterShippingDetail'
import HolterShippngIndex from '@/components/mock/philips/holter/shipping/index'
import HolterPaymentNumberBulkSetting from '@/components/mock/philips/holter/shipping/HolterPaymentNumberBulkSetting'
import HolterInvoiceBulkSetting from '@/components/mock/philips/holter/shipping/HolterInvoiceBulkSetting'
import HolterInvoiceSheetView from '@/components/mock/philips/holter/shipping/HolterInvoiceSheetView'
import HolterLabel12SheetView from '@/components/mock/philips/holter/shipping/HolterLabel12SheetView'
import HolterShippingDirectionsView from '@/components/mock/philips/holter/shipping/HolterShippingDirectionsView'
import HolterNumberOfShipmentSummary from '@/components/mock/philips/holter/HolterNumberOfShipmentSummary'
import HolterDeviceReturn from '@/components/mock/philips/holter/HolterDeviceReturn'
import HolterAnalysisOrder from '@/components/mock/philips/holter/HolterAnalysisOrder'
import HolterAnalysisOrderDetail from '@/components/mock/philips/holter/HolterAnalysisOrderDetail'
import HolterRequestContentChange from '@/components/mock/philips/holter/HolterRequestContentChange'
import HolterDetailEdit from '@/components/mock/philips/holter/HolterDetailEdit'

//社内ユーザー ホルター心電図解析
import HolterAnalysisRequestAccept from '@/components/mock/philips/holterAnalysis/HolterAnalysisRequestAccept'
import HolterAnalysisRequestAcceptDetail from '@/components/mock/philips/holterAnalysis/HolterAnalysisRequestAcceptDetail'
import HolterAnalysisResult from '@/components/mock/philips/holterAnalysis/HolterAnalysisResult'
import HolterAnalysisResultDetail from '@/components/mock/philips/holterAnalysis/HolterAnalysisResultDetail'
import HolterAnalysisApproval from '@/components/mock/philips/holterAnalysis/HolterAnalysisApproval'
import HolterAnalysisApprovalDetail from '@/components/mock/philips/holterAnalysis/HolterAnalysisApprovalDetail'
import HolterJudgment from '@/components/mock/philips/holterAnalysis/HolterJudgment'
import HolterJudgmentDetail from '@/components/mock/philips/holterAnalysis/HolterJudgmentDetail'
import HolterAnalysisReportUpdate from '@/components/mock/philips/holterAnalysis/HolterAnalysisReportUpdate'

//社内ユーザー CPAP案件一覧
import CpapRequestSearch from '@/components/mock/philips/cpap/RequestSearch'
import CpapRequestDetail from '@/components/mock/philips/cpap/RequestDetail'

//社内ユーザー CPAP 預託 院内在庫申請
import CpapEscrowRequestDetail from '@/components/mock/common/CpapEscrowRequestDetail'
import CpapEscrowRequestDetailEdit from '@/components/mock/common/CpapEscrowRequestDetailEdit'

//社内ユーザー CPAP 代理
import cpapHome from '@/components/mock/philips/cpap/cpapHome'
import cpapTempInstalledHome from '@/components/mock/philips/cpap/cpapTempInstalledHome'

//社内ユーザー CPAP コール管理
import CpapFollowUpCallList from '@/components/mock/philips/call/CpapFollowUpCallList'
import CpapFollowUpCallDetail from '@/components/mock/philips/call/CpapFollowUpCallDetail'

//社内ユーザー CPAP エスカレーション管理
import EscalationList from '@/components/mock/philips/escalation/EscalationList'
import EscalationDetail from '@/components/mock/philips/escalation/EscalationDetail'

//社内ユーザー CPAP 機器管理
import CpapReturnManagement from '@/components/mock/philips/cpap/CpapReturnManagement'

//社内ユーザー CPAP 預託
import CpapRequestHome from '@/components/mock/philips/cpap/CpapRequestHome'

//社内企業検診
import KenshinDivisionRequestAccept from '@/components/mock/philips/kenshin/KenshinDivisionRequestAccept'
import KenshinDivisionRequestAcceptDetail from '@/components/mock/philips/kenshin/KenshinDivisionRequestAcceptDetail'
import KenshinRequestAccept from '@/components/mock/philips/kenshin/KenshinRequestAccept'
import KenshinRequestAcceptDetail from '@/components/mock/philips/kenshin/KenshinRequestAcceptDetail'
import KenshinDevicePreparation from '@/components/mock/philips/kenshin/KenshinDevicePreparation'
import KenshinDevicePreparationDetail from '@/components/mock/philips/kenshin/KenshinDevicePreparationDetail'
import KenshinShippingList from '@/components/mock/philips/kenshin/KenshinShippingList'
import KenshinShippingListDetail from '@/components/mock/philips/kenshin/KenshinShippingListDetail'
import KenshinInvoiceSheetView from '@/components/mock/philips/kenshin/shipping/KenshinInvoiceSheetView'
import KenshinDeviceReturn from '@/components/mock/philips/kenshin/KenshinDeviceReturn'
import KenshinExtractData from '@/components/mock/philips/kenshin/KenshinExtractData'
import KenshinJudgmentOrder from '@/components/mock/philips/kenshin/KenshinJudgmentOrder'
import KenshinJudgmentOrderDetailList from '@/components/mock/philips/kenshin/KenshinJudgmentOrderDetailList'
import KenshinJudgmentOrderDetailone from '@/components/mock/philips/kenshin/KenshinJudgmentOrderDetailone'
import KenshinReportCreate from '@/components/mock/philips/kenshin/KenshinReportCreate'
import KenshinRequestSearch from '@/components/mock/philips/kenshin/KenshinRequestSearch'
import KenshinRequestSearchDetail from '@/components/mock/philips/kenshin/KenshinRequestSearchDetail'
import KenshinRequestContentChange from '@/components/mock/philips/kenshin/KenshinRequestContentChange'
import KenshinDetailEdit from '@/components/mock/philips/kenshin/KenshinDetailEdit'
//社内カレンダー
import ShippingCalender from '@/components/mock/philips/calender/ShippingCalender'
//社内集計表
import SpreadSheetMenu from '@/components/mock/philips/spreadSheet/menu'
import TotalInspectionsSummary from '@/components/mock/philips/spreadSheet/TotalInspectionsSummary'
import ShppingMonthlySummary from '@/components/mock/philips/spreadSheet/ShppingMonthlySummary'
import HSTDailySummary from '@/components/mock/philips/spreadSheet/HSTDailySummary'
import InspectionsSpecification from '@/components/mock/philips/spreadSheet/InspectionsSpecification'
import HolterInspectionsSpecification from '@/components/mock/philips/spreadSheet/HolterInspectionsSpecification'
import AnalysisReport from '@/components/mock/philips/spreadSheet/AnalysisReport'
import KenshinJugdmentMonthlyReport from '@/components/mock/philips/spreadSheet/KenshinJugdmentMonthlyReport'
import PsgAnalysisRequest from '@/components/mock/philips/spreadSheet/PsgAnalysisRequest'
import KenshinDateExtract from '@/components/mock/philips/spreadSheet/KenshinDateExtract'

//社内外部ユーザー管理
import ExternalUserControlSearch from '@/components/mock/philips/user/ExternalUserControlSearch'
//社内ユーザープロファイル
import UserProfile from '@/components/mock/philips/profile/UserProfile'
//社内ケアオーケストレーター
import CORequestAccept from '@/components/mock/philips/careorchestrator/CORequestAccept'
import CORequestAcceptDetail from '@/components/mock/philips/careorchestrator/CORequestAcceptDetail'
import CORequestAcceptEdit from '@/components/mock/philips/careorchestrator/CORequestAcceptEdit'
import COUploadCertificate from '@/components/mock/philips/careorchestrator/COUploadCertificate'
import COHome from '@/components/mock/philips/careorchestrator/COHome'
import COSettingClientCertificateInternal from '@/components/mock/philips/careorchestrator/COSettingClientCertificate'
import COSettingHospitalInternal from '@/components/mock/philips/careorchestrator/COSettingHospital'
import COSettingUserInternal from '@/components/mock/philips/careorchestrator/COSettingUser'


//社内管理者関係
//社内機器管理
import DeviceManagement from '@/components/mock/philips/device/DeviceManagement'
import DeviceManagementDetail from '@/components/mock/philips/device/DeviceManagementDetail'
import DeviceStatusBulkChange from '@/components/mock/philips/device/DeviceStatusBulkChange'
import DeviceAdd from '@/components/mock/philips/device/DeviceAdd'
import DeviceKindManagement from '@/components/mock/philips/device/DeviceKindManagement'
import ReturnDelayedManagement from '@/components/mock/philips/device/ReturnDelayedManagement'

//社内マスタ内部ユーザー管理
import InternalUserSearch from '@/components/mock/philips/master/user/InternalUserSearch'
import InternalUserAdd from '@/components/mock/philips/master/user/InternalUserAdd'
import InternalUserEdit from '@/components/mock/philips/master/user/InternalUserEdit'
//社内マスタ外部ユーザー管理
import ExternalUserSearch from '@/components/mock/philips/master/user/ExternalUserSearch'
import ExternalUserAdd from '@/components/mock/philips/master/user/ExternalUserAdd'
import ExternalUserEdit from '@/components/mock/philips/master/user/ExternalUserEdit'
import DealerFacilitySetting from '@/components/mock/philips/master/user/DealerFacilitySetting'

//社内マスタお知らせ管理
import NoticeEdit from '@/components/mock/philips/master/notice/NoticeEdit'
//社内マスタマスター管理
import MasterMaint from '@/components/mock/philips/master/master/MasterMaint'
//社内マスタ同意文管理
import AgreementEdit from '@/components/mock/philips/master/agreement/AgreementEdit'
//社内マスタリストボックス管理
import ListEdit from '@/components/mock/philips/master/list/ListEdit'
//社内マスタ検査品目管理
import ExamItemsEdit from '@/components/mock/philips/master/list/ExamItemsEdit'

//社内マスタデータ管理(NDSS向け)
import dataManagement from '@/components/mock/philips/master/nonAdmin/DataManagement'

//社外転院先紹介
import IntroductionRequest from '@/components/mock/guest/introduction/IntroductionRequest'
import IntroductionReceive from '@/components/mock/guest/introduction/IntroductionReceive'

// ポータル設定
import PortalSetting from './components/mock/philips/portal/PortalSetting.vue';
import PortalArticleEdit from './components/mock/philips/portal/PortalArticleEdit.vue';

//ホルター患者レポート確認用リダイレクトページ
import HolterPatientReportRedirect from '@/components/mock/guest//HolterPatientReportRedirect'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    // 社内向け共通
    {
      path: '/philips',
      component: philipsIndex,
      children: [
        // HOME
        {
          name: 'home',
          path: 'home',
          component: philipsHome
        },
        //作成中（仮表示用）
        {
          name: 'NowCreating',
          path: 'NowCreating',
          component: NowCreating
        },
      ]
    },
    {
      path: '/philips/dev',
      component: philipsIndex,
      children: [
        // HOME
        {
          name: 'devToolHome',
          path: 'devToolHome',
          component: devToolHome
        }
      ]
    },
    // 社内案件一覧
    {
      path: '/philips/search',
      component: philipsIndex,
      children: [
        //案件検索
        {
          name: 'RequestSearch',
          path: 'RequestSearch',
          component: RequestSearch,
          props: true
        },
        //案件詳細
        {
          name: 'RequestDetail',
          path: 'RequestDetail',
          component: RequestDetail,
          props: true
        },
        //案件詳細(企業検診)
        {
          name: 'RequesKenshintDetail',
          path: 'RequesKenshintDetail',
          component: RequesKenshintDetail,
          props:true
        },
      ]
    },
    // 社内案件一覧(CPAP)
    {
      path: '/philips/cpap',
      component: philipsIndex,
      children: [
        //案件検索
        {
          name: 'CpapRequestSearch',
          path: 'RequestSearch',
          component: CpapRequestSearch,
          props: true
        },
        //案件詳細
        {
          name: 'CpapRequestDetail',
          path: 'RequestDetail',
          component: CpapRequestDetail,
          props: true
        },
      ]
    },
    // 社内向け代理申込み
    {
      path: '/philips/offer',
      component: philipsIndex,
      children: [
        //代理申込みホーム
        {
          name: 'offerHome',
          path: 'offerHome',
          component: offerHome
        },
        //HST検査代理申込み
        {
          name: 'HSTAgentRequest',
          path: 'HSTAgentRequest',
          component: HSTRequest,
          props: true
        },
        //HST結果送付先出力
        {
          name: 'HSTAgentLabelPrint',
          path: 'HSTAgentLabelPrint',
          component: HSTAgentLabelPrint,
          props: true
        },
        //PSG解析代理申込み
        {
          name: 'PSGAgentRequest',
          path: 'PSGAgentRequest',
          component: PSGRequest,
          props: true
        },
        //企業検診代理申込み
        {
          name: 'KenshinAgentRequest',
          path: 'KenshinAgentRequest',
          component: KenshinRequest,
          props: true
        },
        //ホルター心電図配送ｻｰﾋﾞｽ代理申込み
        {
          name: 'HolterAgentRequest',
          path: 'HolterAgentRequest',
          component: HolterRequest,
          props: true
        },
        //ホルター心電図解析代理申込み
        {
          name: 'HolterAnalysisAgentRequest',
          path: 'HolterAnalysisAgentRequest',
          component: HolterAnalysisRequest,
          props: true
        },
        //ホルター心電図・院内貸出機登録画面
        {
          name: 'HolterDepositMachineRequest',
          path: 'HolterDepositMachineRequest',
          component: HolterDepositMachineRequest,
          props: true
        },
      ]
    },
    // 社内向けHST
    {
      path: '/philips/hst',
      component: philipsIndex,
      children: [
        //HST受付一覧
        {
          name: 'HSTRequestAccept',
          path: 'HSTRequestAccept',
          component: HSTRequestAccept
        },
        //HST受付
        {
          name: 'HSTRequestAcceptDetail',
          path: 'HSTRequestAcceptDetail',
          component: HSTRequestAcceptDetail
        },
        //HST機器準備一覧
        {
          name: 'HSTDevicePreparation',
          path: 'HSTDevicePreparation',
          component: HSTDevicePreparation
        },
        //HST機器準備
        {
          name: 'HSTDevicePreparationDetail',
          path: 'HSTDevicePreparationDetail',
          component: HSTDevicePreparationDetail
        },
        //HST機器出荷
        {
          name: 'HSTShippingList',
          path: 'HSTShippingList',
          component: HSTShippingList
        },
        //HST機器出荷詳細
        {
          name: 'HSTShippingDetail',
          path: 'HSTShippingDetail',
          component: HSTShippingDetail
        },
        {
          path: '/invoice',
          component: shippngIndex,
          children: [
            //着払い番号一括設定
            {
              name: 'HSTPaymentNumberBulkSetting',
              path: 'HSTPaymentNumberBulkSetting',
              component: HSTPaymentNumberBulkSetting
            },
            //HST送り状一括設定
            {
              name: 'HSTInvoiceBulkSetting',
              path: 'HSTInvoiceBulkSetting',
              component: HSTInvoiceBulkSetting
            },
            //送り状作成シート表示
            {
              name: 'HSTInvoiceSheetView',
              path: 'HSTInvoiceSheetView',
              component: HSTInvoiceSheetView
            },
            //ラベル12シート表示
            {
              name: 'HSTLabel12SheetView',
              path: 'HSTLabel12SheetView',
              component: HSTLabel12SheetView
            },
            //HST出荷指示書表示
            {
              name: 'HSTShippingDirectionsView',
              path: 'HSTShippingDirectionsView',
              component: HSTShippingDirectionsView
            },
          ]
        },
        //HST自宅配送出荷実績シート
        {
          name: 'HSTNumberOfShipmentSummary',
          path: 'HSTNumberOfShipmentSummary',
          component: HSTNumberOfShipmentSummary
        },
        //HST機器受領
        {
          name: 'HSTDeviceReturn',
          path: 'HSTDeviceReturn',
          component: HSTDeviceReturn
        },
        //HST解析申込
        {
          name: 'HSTAnalysisOrder',
          path: 'HSTAnalysisOrder',
          component: HSTAnalysisOrder
        },
        //HST解析申込詳細
        {
          name: 'HSTAnalysisOrderDetail',
          path: 'HSTAnalysisOrderDetail/:receiptNumber',
          component: HSTAnalysisOrderDetail,
          props:true
        },
        // HST案件検索
        {
          path: 'HSTRequestSearch',
          name: 'HSTRequestSearch',
          component: HSTRequestSearch,
        },
        // HST案件検索詳細
        {
          path: 'HSTRequestSearch/detail',
          name: 'HSTRequestSearchDetail',
          component: HSTRequestSearchDetail
        },
        //解析内容変更(検索)
        {
          name: 'HSTRequestContentChange',
          path: 'HSTRequestContentChange',
          component: HSTRequestContentChange
        },
        //解析内容変更
        {
          name: 'HSTDetailEdit',
          path: 'HSTDetailEdit',
          component: HSTDetailEdit
        },
      ]
    },
    // 社内向けPSG
    {
      path: '/philips/psg',
      component: philipsIndex,
      children: [
        //PSG受付一覧
        {
          name: 'PSGRequestAccept',
          path: 'PSGRequestAccept',
          component: PSGRequestAccept
        },
        //PSG受付
        {
          name: 'PSGRequestAcceptDetail',
          path: 'PSGRequestAcceptDetail',
          component: PSGRequestAcceptDetail
        },
        //PSG解析結果入力
        {
          name: 'PSGAnalyisisResult',
          path: 'PSGAnalyisisResult',
          component: PSGAnalyisisResult
        },
        //PSG解析結果詳細
        {
          name: 'PSGAnalyisisResultDetail',
          path: 'PSGAnalyisisResultDetail',
          component: PSGAnalyisisResultDetail
        },
        //PSG解析結果承認
        {
          name: 'PSGApproval',
          path: 'PSGApproval',
          component: PSGApproval
        },
        //PSG解析結果承認詳細
        {
          name: 'PSGApprovalDetail',
          path: 'PSGApprovalDetail',
          component: PSGApprovalDetail
        },

      ]
    },

    // 社内ユーザー ホルター心電図配送ｻｰﾋﾞｽ
    {
      path: '/philips/holter',
      component: philipsIndex,
      children: [
        //受付一覧
        {
          name: 'HolterRequestAccept',
          path: 'HolterRequestAccept',
          component: HolterRequestAccept
        },
        //受付
        {
          name: 'HolterRequestAcceptDetail',
          path: 'HolterRequestAcceptDetail',
          component: HolterRequestAcceptDetail
        },
        //機器準備一覧
        {
          name: 'HolterDevicePreparation',
          path: 'HolterDevicePreparation',
          component: HolterDevicePreparation
        },
        //機器準備
        {
          name: 'HolterDevicePreparationDetail',
          path: 'HolterDevicePreparationDetail',
          component: HolterDevicePreparationDetail
        },
        //機器出荷
        {
          name: 'HolterShippingList',
          path: 'HolterShippingList',
          component: HolterShippingList
        },
        //機器出荷詳細
        {
          name: 'HolterShippingDetail',
          path: 'HolterShippingDetail',
          component: HolterShippingDetail
        },
        {
          path: '/invoice',
          component: HolterShippngIndex,
          children: [
            //着払い番号一括設定
            {
              name: 'HolterPaymentNumberBulkSetting',
              path: 'HolterPaymentNumberBulkSetting',
              component: HolterPaymentNumberBulkSetting
            },
            //送り状一括設定
            {
              name: 'HolterInvoiceBulkSetting',
              path: 'HolterInvoiceBulkSetting',
              component: HolterInvoiceBulkSetting
            },
            //送り状作成シート表示
            {
              name: 'HolterInvoiceSheetView',
              path: 'HolterInvoiceSheetView',
              component: HolterInvoiceSheetView
            },
            //ラベル12シート表示
            {
              name: 'HolterLabel12SheetView',
              path: 'HolterLabel12SheetView',
              component: HolterLabel12SheetView
            },
            //出荷指示書表示
            {
              name: 'HolterShippingDirectionsView',
              path: 'HolterShippingDirectionsView',
              component: HolterShippingDirectionsView
            },
          ]
        },
        //自宅配送出荷実績シート
        {
          name: 'HolterNumberOfShipmentSummary',
          path: 'HolterNumberOfShipmentSummary',
          component: HolterNumberOfShipmentSummary
        },
        //機器受領
        {
          name: 'HolterDeviceReturn',
          path: 'HolterDeviceReturn',
          component: HolterDeviceReturn
        },
        //解析申込
        {
          name: 'HolterAnalysisOrder',
          path: 'HolterAnalysisOrder',
          component: HolterAnalysisOrder
        },
        //HST解析申込詳細
        {
          name: 'HolterAnalysisOrderDetail',
          path: 'HolterAnalysisOrderDetail/:receiptNumber',
          component: HolterAnalysisOrderDetail,
          props:true
        },
        //解析内容変更(検索)
        {
          name: 'HolterRequestContentChange',
          path: 'HolterRequestContentChange',
          component: HolterRequestContentChange
        },
        //受付内容変更
        {
          name: 'HolterDetailEdit',
          path: 'HolterDetailEdit',
          component: HolterDetailEdit
        },
      ]
    },
    // 社内ユーザー ホルター心電図解析
    {
      path: '/philips/holterAnalysis',
      component: philipsIndex,
      children: [
        //受付一覧
        {
          name: 'HolterAnalysisRequestAccept',
          path: 'HolterAnalysisRequestAccept',
          component: HolterAnalysisRequestAccept
        },
        //受付
        {
          name: 'HolterAnalysisRequestAcceptDetail',
          path: 'HolterAnalysisRequestAcceptDetail',
          component: HolterAnalysisRequestAcceptDetail
        },
        //解析結果入力
        {
          name: 'HolterAnalysisResult',
          path: 'HolterAnalysisResult',
          component: HolterAnalysisResult
        },
        //解析結果詳細
        {
          name: 'HolterAnalysisResultDetail',
          path: 'HolterAnalysisResultDetail',
          component: HolterAnalysisResultDetail
        },
        //承認
        {
          name: 'HolterAnalysisApproval',
          path: 'HolterAnalysisApproval',
          component: HolterAnalysisApproval
        },
        //承認詳細
        {
          name: 'HolterAnalysisApprovalDetail',
          path: 'HolterAnalysisApprovalDetail',
          component: HolterAnalysisApprovalDetail
        },
        //判定医
        {
          name: 'HolterJudgment',
          path: 'HolterJudgment',
          component: HolterJudgment
        },
        //判定医詳細
        {
          name: 'HolterJudgmentDetail',
          path: 'HolterJudgmentDetail',
          component: HolterJudgmentDetail
        },
        //レポート更新
        {
          name: 'HolterAnalysisReportUpdate',
          path: 'HolterAnalysisReportUpdate',
          component: HolterAnalysisReportUpdate
        }
      ]
    },
    // 社内向け企業検診
    {
      path: '/philips/kenshin',
      component: philipsIndex,
      children: [
        //企業検診グループ受付一覧
        {
          name: 'KenshinDivisionRequestAccept',
          path: 'KenshinDivisionRequestAccept',
          component: KenshinDivisionRequestAccept
        },
        //企業検診グループ受付詳細
        {
          name: 'KenshinDivisionRequestAcceptDetail',
          path: 'KenshinDivisionRequestAcceptDetail',
          component: KenshinDivisionRequestAcceptDetail
        },
        //検診川越受付一覧
        {
          name: 'KenshinRequestAccept',
          path: 'KenshinRequestAccept',
          component: KenshinRequestAccept
        },
        //検診受付詳細
        {
          name: 'KenshinRequestAcceptDetail',
          path: 'KenshinRequestAcceptDetail',
          component: KenshinRequestAcceptDetail
        },
        //検診機器準備
        {
          name: 'KenshinDevicePreparation',
          path: 'KenshinDevicePreparation',
          component: KenshinDevicePreparation
        },
        //検診機器準備詳細
        {
          name: 'KenshinDevicePreparationDetail',
          path: 'KenshinDevicePreparationDetail',
          component: KenshinDevicePreparationDetail,
          props: true
        },        
        //検診機器出荷
        {
          name: 'KenshinShippingList',
          path: 'KenshinShippingList',
          component: KenshinShippingList
        },
        //検診機器出荷詳細
        {
          name: 'KenshinShippingListDetail',
          path: 'KenshinShippingListDetail',
          component: KenshinShippingListDetail,
          props: true,
        },
        {
          path: '/invoice',
          component: shippngIndex,
          children: [
            //送り状作成シート表示
            {
              name: 'KenshinInvoiceSheetView',
              path: 'KenshinInvoiceSheetView',
              component: KenshinInvoiceSheetView
            }
          ]
        },
        //検診機器受領
        {
          name: 'KenshinDeviceReturn',
          path: 'KenshinDeviceReturn',
          component: KenshinDeviceReturn
        },
        //検診判定依頼
        {
          name: 'KenshinExtractData',
          path: 'KenshinExtractData',
          component: KenshinExtractData
        },
        //検診判定依頼
        {
          name: 'KenshinJudgmentOrder',
          path: 'KenshinJudgmentOrder',
          component: KenshinJudgmentOrder
        },
        //検診判定依頼詳細リスト
        {
          name: 'KenshinJudgmentOrderDetailList',
          path: 'KenshinJudgmentOrderDetailList',
          component: KenshinJudgmentOrderDetailList
        },
        //検診判定依頼詳細
        {
          name: 'KenshinJudgmentOrderDetailone',
          path: 'KenshinJudgmentOrderDetailone',
          component: KenshinJudgmentOrderDetailone
        },
        //検診判定結果作成
        {
          name: 'KenshinReportCreate',
          path: 'KenshinReportCreate',
          component: KenshinReportCreate
        },
        //検診案件確認
        {
          name: 'KenshinRequestSearch',
          path: 'KenshinRequestSearch',
          component: KenshinRequestSearch
        },
        //検診案件確認詳細
        {
          name: 'KenshinRequestSearchDetail',
          path: 'KenshinRequestSearchDetail',
          component: KenshinRequestSearchDetail,
          props:true
        },
        //検診内容変更(検索)
        {
          name: 'KenshinRequestContentChange',
          path: 'KenshinRequestContentChange',
          component: KenshinRequestContentChange
        },
        //検診内容変更
        {
          name: 'KenshinDetailEdit',
          path: 'KenshinDetailEdit',
          component: KenshinDetailEdit
        },
      ]
    },
    //社内ユーザー　コール管理
    {
      path: '/philips/call',
      component: philipsIndex,
      children: [
        //一覧
        {
          name: 'CpapFollowUpCallList',
          path: 'CpapFollowUpCallList',
          component: CpapFollowUpCallList
        },
        //詳細
        {
          name: 'CpapFollowUpCallDetail',
          path: 'CpapFollowUpCallDetail',
          component: CpapFollowUpCallDetail
        },
      ]
    },
    //社内ユーザー　エスカレーション管理
    {
      path: '/philips/escalation',
      component: philipsIndex,
      children: [
        //一覧
        {
          name: 'EscalationList',
          path: 'EscalationList',
          component: EscalationList
        },
        //詳細
        {
          name: 'EscalationDetail',
          path: 'EscalationDetail',
          component: EscalationDetail
        },
      ]
    },
    //社内ユーザー　機器管理
    {
      path: '/philips/cpap',
      component: philipsIndex,
      children: [
        //一覧
        {
          name: 'CpapReturnManagement',
          path: 'CpapReturnManagement',
          component: CpapReturnManagement
        },
      ]
    },
    //社内ユーザー　CPAP
    {
      path: '/philips/cpap',
      component: philipsIndex,
      children: [
        //CPAPホーム
        {
          name: 'cpapHome',
          path: 'cpapHome',
          component: cpapHome
        },
        //CPAP処方代理申込み
        {
          name: 'CpapAgentRequest',
          path: 'CpapAgentRequest',
          component: CpapRequest,
          props: true
        },
        // 機器申込み
        {
          path: 'CpapAgentInstrumentRequest',
          name: 'CpapAgentInstrumentRequest',
          component: CpapInstrumentRequest,
          props: true
        },
        // 機器管理
        {
          path: 'CpapAgentInstrumentList',
          name: 'CpapAgentInstrumentList',
          component: CpapInstrumentList
        },
        // 患者管理
        {
          path: 'CpapAgentPatientList',
          name: 'CpapAgentPatientList',
          component: CpapPatientList
        },
        // 患者情報詳細
        {
          path: 'CpapAgentPatientDetail',
          name: 'CpapAgentPatientDetail',
          component: CpapPatientDetail
        },
        // 処方値修正
        {
          path: 'CpapAgentInstrumentDetail',
          name: 'CpapAgentInstrumentDetail',
          component: CpapInstrumentDetail
        },
        // 転院
        {
          path: 'CpapAgentHospitalTransfer',
          name: 'CpapAgentHospitalTransfer',
          component: CpapHospitalTransfer
        },
        // 使用中止
        {
          path: 'CpapAgentCancelDetail',
          name: 'CpapAgentCancelDetail',
          component: CpapCancelDetail
        },
        // 使用明細
        {
          path: 'CpapAgentUsedList',
          name: 'CpapAgentUsedList',
          component: CpapUsedList
        },
        //CPAP仮持出
        {
          name: 'cpapTempInstalledHome',
          path: 'cpapTempInstalledHome',
          component: cpapTempInstalledHome,
          props: true
        },
        //CPAP預託
        {
          name: 'CpapRequestHome',
          path: 'CpapRequestHome',
          component: CpapRequestHome,
          props: true
        },
        //CPAP預託院内在庫代理申込み
        {
          name: 'CpapAgentEscrowRequest',
          path: 'CpapAgentEscrowRequest',
          component: CpapEscrowRequest,
          props: true
        },
        // 院内在庫申込み検索
        {
          name: 'CpapEscrowRequestSearch',
          path: 'CpapEscrowRequestSearch',
          component: CpapEscrowRequestList,
          props: true,
        },
        //院内在庫申込み詳細
        {
          name: 'CpapAgentEscrowRequestDetail',
          path: '../../common/CpapEscrowRequestDetail',
          component: CpapEscrowRequestDetail,
          props: true
        },
      ]
    },
    // 社内向けカレンダー
    {
      path: '/philips/calender',
      component: philipsIndex,
      children: [
        //出荷カレンダー
        {
          name: 'ShippingCalender',
          path: 'ShippingCalender',
          component: ShippingCalender
        },
      ]
    },
    // 社内向け集計表
    {
      path: '/philips/spreadSheet',
      component: philipsIndex,
      children: [
        //集計表メニュー
        {
          name: 'menu',
          path: 'menu',
          component: SpreadSheetMenu
        },   
        //検査/解析件数サマリー
        {
          name: 'TotalInspectionsSummary',
          path: 'TotalInspectionsSummary',
          component: TotalInspectionsSummary
        },
        //月次検査レンタル器出荷数サマリー
        {
          name: 'ShppingMonthlySummary',
          path: 'ShppingMonthlySummary',
          component: ShppingMonthlySummary
        },
        //HST自宅配送サービス集計表
        {
          name: 'HSTDailySummary',
          path: 'HSTDailySummary',
          component: HSTDailySummary
        },
        //検査明細書(睡眠)
        {
          name: 'InspectionsSpecification',
          path: 'InspectionsSpecification',
          component: InspectionsSpecification
        },
        //検査明細書(ホルター心電図)
        {
          name: 'HolterInspectionsSpecification',
          path: 'HolterInspectionsSpecification',
          component: HolterInspectionsSpecification
        },
        //解析業務報告書
        {
          name: 'AnalysisReport',
          path: 'AnalysisReport',
          component: AnalysisReport
        },
        //HolterAnalysisReport
        {
          name: 'HolterAnalysisReport',
          path: 'HolterAnalysisReport',
          component: HolterAnalysisReport
        },
        //企業検診判定医月次レポート
        {
          name: 'KenshinJugdmentMonthlyReport',
          path: 'KenshinJugdmentMonthlyReport',
          component: KenshinJugdmentMonthlyReport
        },
        //ホルター判定医月次レポート
        {
          name: 'HolterAnalysisJugdmentMonthlyReport',
          path: 'HolterAnalysisJugdmentMonthlyReport',
          component: HolterAnalysisJugdmentMonthlyReport
        },
        //PSG解析来件数抽出
        {
          name: 'PsgAnalysisRequest',
          path: 'PsgAnalysisRequest',
          component: PsgAnalysisRequest
        },
        //企業検診データ抽出日件数抽出
        {
          name: 'KenshinDateExtract',
          path: 'KenshinDateExtract',
          component: KenshinDateExtract
        },
      ]
    },
    // 社内ユーザー用 ポータル設定
    {
      path: '/philips/portal-setting',
      component: philipsIndex,
      children: [
        // ポータル設定
        {
          path: '',
          name: 'PortalSetting',
          component: PortalSetting
        },
        // ポータル記事編集
        {
          path: 'article-edit',
          name: 'PortalArticleEdit',
          component: PortalArticleEdit,
        },
      ]
    },
     // 社内向け外部ユーザー管理
    {
      path: '/philips/user',
      component: philipsIndex,
      children: [
        //外部ユーザー管理
        {
          name: 'ExternalUserControlSearch',
          path: 'ExternalUserControlSearch',
          component: ExternalUserControlSearch,
          props:true
        },
      ]
    },
    // 社内向けケアオーケストレーター
    {
      path: '/philips/careorchestrator',
      component: philipsIndex,
      children: [
        //ケアオーケストレーター受付
        {
          name: 'CORequestAccept',
          path: 'CORequestAccept',
          component: CORequestAccept
        },
        //ケアオーケストレーター申請詳細
        {
          name: 'CORequestAcceptDetail',
          path: 'CORequestAcceptDetail',
          component: CORequestAcceptDetail,
          props: true,
        },
        // ケアオーケストレーター編集
        {
          name: 'CORequestAcceptEdit',
          path: 'CORequestAcceptEdit',
          component: CORequestAcceptEdit,
          // props経由で渡したい場合はtrueをセット
          props: true,
        },
        //ケアオーケストレータークライアント証明書
        {
          name: 'COUploadCertificate',
          path: 'COUploadCertificate',
          component: COUploadCertificate,
          props: true,
        },
        //ケアオーケストレーターメニュー  
        {
          name: 'COHome',
          path: 'COHome',
          component: COHome,
          props: true,
        },
        // ケアオーケストレーター施設設定
        {
          path: 'COSettingHospitalInternal',
          name: 'COSettingHospitalInternal',
          component: COSettingHospitalInternal
        },
        // ケアオーケストレーターユーザー設定
        {
          path: 'COSettingUserInternal',
          name: 'COSettingUserInternal',
          component: COSettingUserInternal
        },
        // ケアオーケストレータークライアント証明書
        {
          path: 'COSettingClientCertificateInternal',
          name: 'COSettingClientCertificateInternal',
          component: COSettingClientCertificateInternal
        },
      ]
    },
    // 社内向けユーザープロファイル
    {
      path: '/philips/profile',
      component: philipsIndex,
      children: [
        //ユーザープロファイル
        {
          name: 'UserProfile',
          path: 'UserProfile',
          component: UserProfile
        },
      ]
    },
    // 社内向け機器管理
    {
      path: '/philips/device',
      component: philipsIndex,
      children: [
        //機器一覧
        {
          name: 'DeviceManagement',
          path: 'DeviceManagement',
          component: DeviceManagement
        },
        //機器詳細
        {
          name: 'DeviceManagementDetail',
          path: 'DeviceManagementDetail',
          component: DeviceManagementDetail
        },
        //機器状態一括変更
        {
          name: 'DeviceStatusBulkChange',
          path: 'DeviceStatusBulkChange',
          component: DeviceStatusBulkChange
        },
        //機器追加
        {
          name: 'DeviceAdd',
          path: 'DeviceAdd',
          component: DeviceAdd
        },
        //機種管理
        {
          name: 'DeviceKindManagement',
          path: 'DeviceKindManagement',
          component: DeviceKindManagement
        },
        //返却遅延管理
        {
          name: 'ReturnDelayedManagement',
          path: 'ReturnDelayedManagement',
          component: ReturnDelayedManagement
        }
        
      ]
    },
    // 社内向け内部ユーザー管理
    {
      path: '/philips/master/user',
      component: philipsIndex,
      children: [
        // マスタメンテナンス(内部ユーザー検索)
        {
          name: 'InternalUserSearch',
          path: 'InternalUserSearch',
          component: InternalUserSearch
        },
        // マスタメンテナンス(内部ユーザー情報編集)
        {
          name: 'InternalUserEdit',
          path: 'InternalUserEdit',
          component: InternalUserEdit
        },
        // マスタメンテナンス(内部ユーザー登録)
        {
          name: 'InternalUserAdd',
          path: 'InternalUserAdd',
          component: InternalUserAdd
        },
      ]
    },
    // 社内向け外部ユーザー管理
    {
      path: '/philips/master/user',
      component: philipsIndex,
      children: [
        // マスタメンテナンス(外部ユーザー検索)
        {
          name: 'ExternalUserSearch',
          path: 'ExternalUserSearch',
          component: ExternalUserSearch
        },
        // マスタメンテナンス(外部ユーザー情報編集)
        {
          name: 'ExternalUserEdit',
          path: 'ExternalUserEdit',
          component: ExternalUserEdit
        },
        // マスタメンテナンス(外部ユーザー登録)
        {
          name: 'ExternalUserAdd',
          path: 'ExternalUserAdd',
          component: ExternalUserAdd,
          props:true
        },
        // マスタメンテナンス(外部ディーラー施設見積情報)
        {
          name: 'DealerFacilitySetting',
          path: 'DealerFacilitySetting',
          component: DealerFacilitySetting,
          props:true
        },
      ]
    },
    //社内マスターお知らせ管理
    {
      path: '/philips/master/notice',
      component: philipsIndex,
      children: [
        // お知らせ管理
        {
          name: 'NoticeEdit',
          path: 'NoticeEdit',
          component: NoticeEdit
        },
      ]
    },
    //社内マスターマスター管理
    {
      path: '/philips/master/master',
      component: philipsIndex,
      children: [
        // マスター管理
        {
          name: 'MasterMaint',
          path: 'MasterMaint',
          component: MasterMaint
        },
      ]
    },
    //社内マスター同意書管理
    {
      path: '/philips/master/agreement',
      component: philipsIndex,
      children: [
        // 同意書管理
        {
          name: 'AgreementEdit',
          path: 'AgreementEdit',
          component: AgreementEdit
        },
      ]
    },
    //社内マスターリスト管理
    {
      path: '/philips/master/list',
      component: philipsIndex,
      children: [
        // リストボックス管理
        {
          name: 'ListEdit',
          path: 'ListEdit',
          component: ListEdit
        },
        // 検査品目管理
        {
          name: 'ExamItemsEdit',
          path: 'ExamItemsEdit',
          component: ExamItemsEdit
        },
        
      ]
    },
    //社内マスタデータ管理(NDSS向け)
    {
      path: '/philips',
      component: philipsIndex,
      children: [
        // dataManagement
        {
          name: 'dataManagement',
          path: 'dataManagement',
          component: dataManagement
        }
      ]
    },

    //ゲスト向け
    {
      path: '/guest',
      component: guestIndex,
      children: [
        // HOME
        {
          name: 'guestHome',
          path: 'home',
          component: guestHome
        },
        // kensaMenu
        {
          name: 'kensaMenu',
          path: 'kensaMenu',
          component: kensaMenu
        },
        // kensaMenu
        {
          name: 'holterMenu',
          path: 'holterMenu',
          component: holterMenu
        },
        //HSTRequest
        {
          name: 'HSTRequest',
          path: 'HSTRequest',
          component: HSTRequest,
          props: true
        },
        //PSGRequest
        {
          name: 'PSGRequest',
          path: 'PSGRequest',
          component: PSGRequest,
          props: true
        },
        //KenshinRequest
        {
          name: 'KenshinRequest',
          path: 'KenshinRequest',
          component: KenshinRequest
        },
        //RequestFormList
        {
          name: 'RequestFormList',
          path: 'RequestFormList',
          component: RequestFormList
        },
        //IntroductionRequest
        {
          name: 'IntroductionRequest',
          path: 'IntroductionRequest',
          component: IntroductionRequest
        },
        //DealersFacilityManagement
        {
          name: 'DealersFacilityManagement',
          path: 'DealersFacilityManagement',
          component: DealersFacilityManagement
        },
        //GuestSetting
        {
          name: 'GuestSetting',
          path: 'GuestSetting',
          component: GuestSetting
        },
        //KenshinJudgment
        {
          name: 'KenshinJudgment',
          path: 'KenshinJudgment',
          component: KenshinJudgment
        },
        //KenshinJudgmentDetail
        {
          name: 'KenshinJudgmentDetail',
          path: 'KenshinJudgmentDetail',
          component: KenshinJudgmentDetail,
          props: true
        },
        //HolterAnalysisJudgment
        {
          name: 'HolterAnalysisJudgment',
          path: 'HolterAnalysisJudgment',
          component: HolterAnalysisJudgment
        },
        //HolterAnalysisJudgmentDetail
        {
          name: 'HolterAnalysisJudgmentDetail',
          path: 'HolterAnalysisJudgmentDetail',
          component: HolterAnalysisJudgmentDetail,
          props: true
        },
        //ホルター判定医月次レポート
        {
          name: 'HolterAnalysisJugdmentMonthlyReport',
          path: 'HolterAnalysisJugdmentMonthlyReport',
          component: HolterAnalysisJugdmentMonthlyReport
        },
        //PSGAnalysisOrder
        {
          name: 'PSGAnalysisOrder',
          path: 'PSGAnalysisOrder',
          component: PSGAnalysisOrder
        },
        // PSGAnalysisOrderDetail
        {
          name: 'PSGAnalysisOrderDetail',
          path: 'PSGAnalysisOrderDetail',
          component: PSGAnalysisOrderDetail
        },
        // AnalysisReportGuest
        {
          name: 'AnalysisReportGuest',
          path: 'AnalysisReportGuest',
          component: AnalysisReportGuest
        },
        //HolterRequest
        {
          name: 'HolterRequest',
          path: 'HolterRequest',
          component: HolterRequest,
          props: true
        },
        //HolterAnalysisRequest
        {
          name: 'HolterAnalysisRequest',
          path: 'HolterAnalysisRequest',
          component: HolterAnalysisRequest,
          props: true
        },
        //HolterAnalysisJudgment
        {
          name: 'HolterAnalysisJudgment',
          path: 'HolterAnalysisJudgment',
          component: HolterAnalysisJudgment
        },
        //HolterAnalysisJudgmentDetail
        {
          name: 'HolterAnalysisJudgmentDetail',
          path: 'HolterAnalysisJudgmentDetail',
          component: HolterAnalysisJudgmentDetail,
          props: true
        },
        //HolterDepositMachineList,
        {
          name: 'HolterDepositMachineList',
          path: 'HolterDepositMachineList',
          component: HolterDepositMachineList,
          props: true
        },
        //HolterDepositMachineRequestFormOrder
        {
          name: 'HolterDepositMachineRequestFormOrder',
          path: 'HolterDepositMachineRequestFormOrder',
          component: HolterDepositMachineRequestFormOrder,
          props: true
        },
        //HolterAnalysisResultGuest
        {
          name: 'HolterAnalysisResultGuest',
          path: 'HolterAnalysisResultGuest',
          component: HolterAnalysisResultGuest,
          props: true
        },
        //HolterAnalysisResultGuestDetail
        {
          name: 'HolterAnalysisResultGuestDetail',
          path: 'HolterAnalysisResultGuestDetail',
          component: HolterAnalysisResultGuestDetail,
          props: true
        },
        // 掲載記事一覧画面
        {
          name: 'ArticleList',
          path: 'article-list',
          component: ArticleList
        },
        // 点検報告書一覧画面
        {
          name: 'inspectionReportList',
          path: 'inspectionReportList',
          component: inspectionReportList,
          props: true,
        },
        // 点検報告書参照
        {
          name: 'InspectionReportView',
          path: 'InspectionReportView',
          component: InspectionReportView,
          props: true,
        },
      ]
    },
    //ゲスト向けケアオーケストレーター
    {
      path: '/guest/careorchestrator',
      component: guestIndex,
      children: [
        // ケアオーケストレーター申請
        {
          path: 'CORegistRequest',
          name: 'CORegistRequest',
          component: CORegistRequest
        },
        // 利用中ケアオーケストレーター申請
        {
          path: 'COApplicationForRegistered',
          name: 'COApplicationForRegistered',
          component: COApplicationForRegistered
        },
        // ケアオーケストレーター施設設定
        {
          path: 'COSettingHospital',
          name: 'COSettingHospital',
          component: COSettingHospital
        },
        // ケアオーケストレーターユーザー設定
        {
          path: 'COSettingUser',
          name: 'COSettingUser',
          component: COSettingUser
        },
        // ケアオーケストレーター申請一覧
        {
          path: 'COSettingRequestList',
          name: 'COSettingRequestList',
          component: COSettingRequestList
        },
        // ケアオーケストレータークライアント証明書
        {
          path: 'COSettingClientCertificate',
          name: 'COSettingClientCertificate',
          component: COSettingClientCertificate
        },
        // ケアオーケストレーターディーラーメニュー
        {
          path: 'CODealerMenu',
          name: 'CODealerMenu',
          component: CODealerMenu
        },
        // ケアオーケストレーターディーラー施設検索
        {
          path: 'CODealerHospitalSearch',
          name: 'CODealerHospitalSearch',
          component: CODealerHospitalSearch
        },
        // ケアオーケストレーターディーラー施設設定
        {
          path: 'CODealerSettingHospital',
          name: 'CODealerSettingHospital',
          component: CODealerSettingHospital
        },
        // ケアオーケストレーターディーラーユーザー設定
        {
          path: 'CODealerSettingUser',
          name: 'CODealerSettingUser',
          component: CODealerSettingUser
        },
        // ケアオーケストレーターディーラー申請一覧
        {
          path: 'CODealerRequestList',
          name: 'CODealerRequestList',
          component: CODealerRequestList
        },
        // ケアオーケストレーターディーラー証明書情報
        {
          path: 'CODealerSettingClientCertificate',
          name: 'CODealerSettingClientCertificate',
          component: CODealerSettingClientCertificate
        },
      ]
    },//ゲスト向けCPAP
    {
      path: '/guest/cpap',
      component: guestIndex,
      children: [
        // メニュー
        {
          path: 'CpapMenu',
          name: 'CpapMenu',
          component: CpapMenu
        },
        // 処方申込み
        {
          path: 'CpapRequest',
          name: 'CpapRequest',
          component: CpapRequest,
          props: true
        },
        // 保存済み処方確認・再開
        {
          path: 'CpapRequestDraftView',
          name: 'CpapRequestDraftView',
          component: CpapRequestDraftView,
        },
        // 機器申込み
        {
          path: 'CpapInstrumentRequest',
          name: 'CpapInstrumentRequest',
          component: CpapInstrumentRequest,
          props: true
        },
        // 機器管理
        {
          path: 'CpapInstrumentList',
          name: 'CpapInstrumentList',
          component: CpapInstrumentList
        },
        // 患者管理
        {
          path: 'CpapPatientList',
          name: 'CpapPatientList',
          component: CpapPatientList
        },
        // 患者情報詳細
        {
          path: 'CpapPatientDetail',
          name: 'CpapPatientDetail',
          component: CpapPatientDetail,
          props: true
        },
        // 処方値修正
        {
          path: 'CpapInstrumentDetail',
          name: 'CpapInstrumentDetail',
          component: CpapInstrumentDetail
        },
        // 転院
        {
          path: 'CpapHospitalTransfer',
          name: 'CpapHospitalTransfer',
          component: CpapHospitalTransfer
        },
        // 使用中止
        {
          path: 'CpapCancelDetail',
          name: 'CpapCancelDetail',
          component: CpapCancelDetail
        },
        // 使用明細
        {
          path: 'CpapUsedList',
          name: 'CpapUsedList',
          component: CpapUsedList
        },
        // 申請一覧
        {
          path: 'CpapRequestList',
          name: 'CpapRequestList',
          component: CpapRequestList
        },
        // 申請詳細
        {
          name: 'CpapGuestRequestDetail',
          path: 'CpapRequestDetail',
          component: CpapGuestRequestDetail,
          props: true
        },
        // デフォルト値設定一覧
        {
          name: 'CpapDefaultSettingList',
          path: 'CpapDefaultSettingList',
          component: CpapDefaultSettingList,
          props: true
        },
        // デフォルト値設定
        {
          name: 'CpapDefaultSetting',
          path: 'CpapDefaultSetting',
          component: CpapDefaultSetting,
          props: true
        },
        // 預託メニュー
        {
          name: 'CpapRequestMenu',
          path: 'CpapRequestMenu',
          component: CpapRequestMenu
        },
        // 預託院内在庫申し込み
        {
          name: 'CpapEscrowRequest',
          path: 'CpapEscrowRequest',
          component: CpapEscrowRequest
        },
        // 預託院内在庫申し込み履歴
        {
          name: 'CpapEscrowRequestList',
          path: 'CpapEscrowRequestList',
          component: CpapEscrowRequestList,
          props: true
        },
        // 預託院内在庫申し込み詳細
        {
          name: 'CpapGuestEscrowRequestDetail',
          path: 'CpapEscrowRequestDetail',
          component: CpapGuestEscrowRequestDetail,
          props: true
        },
      ]
    },
    //ゲスト向け患者ダッシュボード
    {
      path: '/guest/patientdashboard',
      component: guestIndex,
      children: [
        // 患者ダッシュボードメイン画面
        {
          path: 'PDashboardMain',
          name: 'PDashboardMain',
          component: PDashboardMain,
          props: true
        }
      ]
    },
    // ログイン画面
    {
      path: '/',
      name: 'login',
      component: login
    },
    // SSO認証ログイン画面
    {
      path: '/SSOLogin',
      name: 'SSOLogin',
      component: SSOLogin
    },
    // パスワード初期化
    {
      path: '/pwdInit',
      name: 'AppPasswordInitialization',
      component: AppPasswordInitialization
    },
    // 初期パスワード強制変更
    {
      path: '/pwdchange',
      name: 'AppPasswordForceChange',
      component: AppPasswordForceChange,
      props: true
    },
    //申込み案内
    {
      path: '/top',
      name: 'RegistNavi',
      component: RegistNavi,
    },
    //社外ユーザ申込(医療機関)
    {
      path: '/hregist',
      name: 'hregist',
      component: RegistForm,
    },
    //社外ユーザ申込(医療機関)
    {
      path: '/hregist2',
      name: 'hregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(企業)
    {
      path: '/cregist',
      name: 'cregist',
      component: RegistForm,
    },
    {
      path: '/cregist2',
      name: 'cregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(ディーラー)
    {
      path: '/dregist',
      name: 'dregist',
      component: RegistForm,
    },
    {
      path: '/dregist2',
      name: 'dregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(判定医療機関)
    {
      path: '/jregist',
      name: 'jregist',
      component: RegistForm,
    },
    {
      path: '/jregist2',
      name: 'jregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(ホルター判定医)
    {
      path: '/hjregist',
      name: 'hjregist',
      component: RegistForm,
    },
    {
      path: '/hjregist2',
      name: 'hjregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(解析委託業者)
    {
      path: '/aregist',
      name: 'aregist',
      component: RegistForm,
    },
    {
      path: '/aregist2',
      name: 'aregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(宿泊施設))
    {
      path: '/acregist',
      name: 'acregist',
      component: RegistForm,
    },
    {
      path: '/acregist2',
      name: 'acregist2',
      component: RegistForm2,
    },
    //社外ユーザ申込(ユーザー追加依頼)
    {
      path: '/userAddRegistForm',
      name: 'userAddRegistForm',
      component: userAddRegistForm,
    },
    //申込み内容確認サイト
    {
      path: '/requestViewer',
      name: 'requestViewer',
      component: requestViewer,
    },
    //再検査実施/キャンセルサイト
    {
      path: '/reExaminationAdjustment',
      name: 'reExaminationAdjustment',
      component: reExaminationAdjustment,
    },
    //解析結果ダウンロードサイト
    {
      path: '/result',
      name: 'ResultDownload',
      component: ResultDownload,
    },
    //転院先紹介 申込み/結果ダウンロードサイト
    {
      path: '/IntroductionReceive',
      name: 'IntroductionReceive',
      component: IntroductionReceive
    },
    //預託院内在庫 詳細
    {
      name: 'CpapEscrowRequestDetail',
      path: 'CpapEscrowRequestDetail',
      component: CpapEscrowRequestDetail,
      props: true
    },
    //預託院内在庫 詳細編集
    {
      name: 'CpapEscrowRequestDetailEdit',
      path: 'CpapEscrowRequestDetailEdit',
      component: CpapEscrowRequestDetailEdit,
      props: true
    },
    //ホルター患者レポート確認用リダイレクトページ
    {
      path: '/HolterPatientReportRedirect',
      name: 'HolterPatientReportRedirect',
      component: HolterPatientReportRedirect
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router.js